import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe } from '@ngneat/transloco';


@Component({
  selector: 'app-confirm-delete-modal',
  templateUrl: './confirm-delete-modal.component.html',
  styleUrls: ['./confirm-delete-modal.component.scss'],
  standalone: true,
  imports: [TranslocoPipe],
  providers: [TranslocoPipe]
  
})
export class ConfirmDeleteModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteModalComponent>,
    public translocoPipe: TranslocoPipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onDeleteClick(): void {
    this.dialogRef.close(true);
  }

  getDeleteMessage(): string {
    if (this.data.entityType === 'folder') {
      
      return this.translocoPipe.transform('modal.folder.text')//`Sei sicuro di voler cancellare questa cartella?`;
    }
    return this.translocoPipe.transform('modal.matrix.text') //`Sei sicuro di voler cancellare questa attività?`;
  }
}
